export const getFromLS = (key: string, defaultValue?: unknown) => {
  const value = localStorage.getItem(key);

  if (typeof defaultValue !== 'object') {
    return value || defaultValue;
  }

  try {
    return value ? JSON.parse(value) : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

export const setToLS = (key: string, value: unknown) => {
  localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
};

export const removeFromLS = (key: string) => {
  localStorage.removeItem(key);
};
